const checkIfShouldRenderGtm = (itemsPerPage, listLength, index) => {
  if (!itemsPerPage) return index === 0;
  if (listLength <= itemsPerPage && index === 0) return true;
  const itemListPosition = index + 1;
  if (listLength - itemsPerPage === itemListPosition) return true;
  const isIncompleteList = !Number.isInteger(listLength / itemsPerPage);
  if (isIncompleteList) {
    const currentPage = Math.trunc(listLength / itemsPerPage);
    if (currentPage * itemsPerPage === itemListPosition) return true;
  }
  return false;
};
export default checkIfShouldRenderGtm;
//# sourceMappingURL=check-if-should-render-gtm.js.map